export default "__VITE_ASSET__CRlimY1G__"